export const termsAndConditions = `
<h3>Terms and conditions & Privacy Policy</h3>

<h4>1. BACKGROUND AND PURPOSE</h4>

<p>
OrderX AS offers cashless handling of ordering and payment at festivals / venues / cafés / restaurants under the brand names OrderX and apples.no. You establish an agreement either through using our web app or OrderX's own app. If you create a profile you can register a credit card, mobile phone number and your name. Your registered credit card will be charged when ordering products from one of our merchants. There is no additional fee beyond commodity price indicated for the goods you buy. The service can be used with all approved OrderX merchants.
To simplify future purchases, your credit card information will be stored by our security certified payment partner, Bambora. You will find an updated list of valid merchants in the app or online. https://appless.no. Your chosen payment method(either Vipps or Creditcard) will be debited either instantly when you place your purchase, or when merchant staff is handing your purchased goods out, depending on the merchants preference. 
</p>

<h4>2. ESTABLISHMENT OF AGREEMENT</h4>

<p>
You can sign up either by web or in in app. When doing a purchase you are entering this agreement.
</p>

<h4>3. CHANGES</h4>

<p>
Change of mobile number or personal information must be made either in the APP or on the WEB. Other matters of importance to the agreement must be notified to OrderX AS immediately. Customer is responsible for transactions carried out until the agreement is terminated or modified via the APP or WEB.
</p>

<h4>4. PARTIES</h4>

<p>
All legally competent persons can subscribe to the service from OrderX AS. OrderX AS conveys a service that allows you to carry out ordering and payment. Selling party to a purchase transaction you are conducting will be the actual OrderX merchant you are at. For information about who is selling party, see the receipt of the relevant transaction. You can activate "receipts by email" in your profile page. Our partner for payment services is Bambora, https://bambora.com, which is responsible for the safe storage of card information and carrying out payment transactions, information and credit management, and possibly billing service. The agreement stipulates that Bambora/Visa/Mastercard  is confirming payment responsibility for the customer's credit card.
</p>

<h4>5. PRICES</h4>

<p>
You will be charged the actual defined commodity prices that the merchant has set. OrderX merchants are fully responsible for defining the prices of the goods sold. It occurs no payment beyond this for use of the service. All prices will be inclusive applicable VAT and will be charged in the local currency of the country you are in.
</p>


<h4>6. PAYMENT LIABILITY</h4>

<p>
Customer is responsible for payment of sales transaction, even in cases where we were not able to charge you instantly. This responsibility includes situations where someone else is using your agreement, including unauthorized use, unless it is likely that the
unauthorized use was made possible through the theft of credit card or falsification of identity. You will continuously be able to see all your transactions in your profile page online or in app. If you think something is wrong with a transaction or your account, you need to notify OrderX or the merchant.
</p>

<h4>7. FEE FOR MISSING PAYMENTS</h4>

<p>
If our partners or OrderX are not able to capture the full amount of your purchases, an invoice will be in addition to an administration charge of NOK 65. Upon default of payment we will incur late charges by the prevailing rates. By reopening the agreement, which has been shut due to missing payments, the customer can be charged an opening fee of NOK 300.
</p>

<h4>8. TERMINATION / CLOSURE OF AGREEMENT DUE TO BREACH OF CONTRACT</h4>

<p>
OrderX AS and their Merchants may terminate the agreement with immediate effect by a material breach by the customer. If the customer does not pay by the due date specified in the payment notice, OrderX AS can terminate the service. OrderX AS may also terminate the service if the customer's credit card cannot be charged or if the customer is abusing the service.
</p>


<h4>9. LIABILITY AND FAULT SITUATIONS</h4>

<p>
The service can sometimes be dependent on network services being available when you want to execute a trade. The customer or the merchant must ensure either mobile coverage or coverage through a wireless network for the service to work. OrderX AS cannot be held responsible for the lack of network coverage. Should any other deviations occur, you must inform merchant's staff of this. This includes theft of mobile device when you are visiting merchant. You will be held responsible for purchase transactions until you have notified the merchant. Your bank is free to block future transactions as part of its security policy, should this occur is a matter between you and your bank. In some cases, you will then be able to remedy the situation by contacting your bank.
</p>

<h4>10. SECURITY</h4>

<p>
All communications related to handling of our order management is ensured through encryption. OrderX does not have access to your credit card information. This is stored safely with our partner Bambora and Vipps, which is certified by VISA and MasterCard and has a license from The Financial Supervisory Authority. For your own safety we encourage you to always have the latest updates for your phone installed. We also encourage you to install antivirus and firewall software for added protection of your cell phone. You agree to use the "Lock screen" on your mobile device to prevent any unauthorized purchases on your behalf.You may also be prompted for your personal code for instance with Vipps or BankID, to carry out a purchase.
</p>

<h4>11. CONFIDENTIALITY, STORAGE AND USE OF PERSONAL INFORMATION</h4>

<p>
OrderX has a duty to maintain secrecy about the customer's use of the service. If the customer consents such information can yet be disclosed to other parties. When OrderX is legally obligated by court, prosecutors or other public authority, your customer info will be disclosed. The collected customer data may be distributed to merchants who use the service, for static purposes or to other third parties in non-identifiable, anonymous form. If there are important changes of our service offerings, we will contact you by sms or email.
</p>

<h4>12. DISPUTES</h4>

<p>
Disputes between you and the merchant or OrderX shall be settled amicably. If it is not possible, either party may bring the dispute before the ordinary courts. Jurisdiction is Oslo District Court. Should a dispute occur related to a specific sales transaction carried out by one of our Merchants, this will be a matter between the two active parties in the transaction; you and the selling party (OrderX merchant). You can find what legally party you are purchasing from both in the OrderX solution (receipts can be found under orders in main menu) and in Vipps/ your online bank. 
</p>

<h4>13. DURATION</h4>

<p>
The agreement is valid from the date the credit card will be charged with NOK 1, (from signing up) The agreement runs until the agreement is terminated in writing to OrderX AS
</p>

<h4>14. AMENDMENT OF CONTRACT PROVISIONS</h4>

<p>
Agreements and conditions may be amended or terminated as a result of public orders, regulations, or other circumstances OrderX can not control. Changes in contract provisions will be notified and you can choose to let the service stop.
</p>

<h4>15. CONTACT DETAILS</h4>

<p>
OrderX AS can be contacted here: hello@orderX.no
</p>

<h3>PRIVACY POLICY</h3>
<h4>VILKÅR</h4>

<p>
OrderX AS er ansvarlig for at innsamling av personopplysninger gjennom app og websider foregår på en trygg og sikker måte og i samsvar med gjeldende regelverk. Denne personverklæringen beskriver hvordan vi behandler dine personopplysninger.
</p>

<h4>INNSAMLING OG BEHANDLING AV OPPLYSNINGER</h4>
Når du installerer og bruker appen vår eller bruker vår webapp/webside  vil vi registrere opplysninger som kan knyttes til deg som person. Opplysningene som samles inn og behandles vil være:

<h4>Lokasjon</h4>

<p>
Hvis du installerer appen kan vi spørre deg om mobilenhetens lokasjon. Registrering av lokasjon forutsetter at du har (i) slått på Bluetooth (ii) akseptert lokasjonstjenester i mobilenhetens operativsystem (kun iOS). Du kan når som helst avslutte registreringen av lokasjon gjennom å endre innstillingene, skru av Bluetooth eller ved å avinstallere appen. Du står fritt til å ikke gi oss tilgang til lokasjon. Formålet med å hente lokasjon er å kunne vise deg de nærmeste utsalgsstedene som støtter orderx/ appless.no
</p>

<h4>Informasjon hentet fra mobilenheten </h4>

<p>
Vi kan registrere informasjon som appen henter fra mobilenheten, se punktet om tilganger nedenfor. Hvis du bruker webversjonen av løsningen vår benytter vi cookies for å kunne bruke analyseverktøy som lar oss forstå hvordan kundene bruker løsningen. Vi bruker også cookies til å vise dine tidligere gjennomførte kjøp, siden vi ikke krever noen registrering av personlige opplysninger som for eksempel navn, mobilnummer osv.
</p>

<p>
Formålet med å analysere hvordan brukerne oppfører seg , er å  videreutvikle, forenkle og forbedre våre tjenester.
</p>

<h4>Brukerinformasjon</h4>

<p>Dersom du velger å lage et brukernavn(som ikke er påkrevd for å kjøpe i løsningen), vil vi lagre:</p>

<ul>
<li>Fornavn</li>
<li>Etternavn</li>
<li>E-post</li>
<li>Mobilnummer</li>
</ul>

<p>
Formålet er å kunne opprette en gyldig verifisert bruker i løsningen, slik at vi kan gi deg tilgang for eksempel til tidligere kvitteringer. Vi vil slette brukerinformasjonen din hvis det er mer enn 9 måneder siden sist du benyttet kontoen din.
</p>
<p>OrderX kan bruke informasjonen som samles inn gjennom appen sammen med andre opplysninger vi har registrert om deg.</p>

<h4>TILGANGER</h4>
<p>Appen kan be deg om følgende tilganger fra mobilenheten:</p>

<ul>
<li>Lokasjon</li>
<li>Varslinger</li>
<li>Blåtann</li>
</ul>

<h4>INNSYN</h4>
<p>
Du har rett til å kreve innsyn i hvilke personopplysninger som er lagret hos OrderX. En slik begjæring om innsyn kan fremsettes ved å kontakte oss som beskrevet nedenfor.
</p>

<h4>Deling av data</h4>
<p>
Vi deler kun data relatert til din bruk av løsningen med relevante og nødvendige samarbeidspartnere som trengs for å kunne gjennomføre en transaksjon. Vi har databehandleravtale med alle nødvendige parter. Vi vil aldri selge data relatert til din bruk til 3. parter, verken som isolerte data eller aggregerte data.
</p>



<h4>SLETTING</h4>
<p>
Dine personopplysninger vil bli lagret så lenge det er nødvendig for å oppfylle formålet med behandlingen, deretter vil de bli slettet. Du har rett til å kreve at vi sletter dine personopplysninger når som helst. Krav om sletting av personopplysningene kan fremsettes ved å kontakte oss som beskrevet nedenfor.
</p>

<h4>SIKKERHET</h4>
<p>
Vi bruker flere sikkerhetsteknologier for å beskytte informasjonen mot uautorisert tilgang, blant annet ved at lagring skjer på servere med begrenset tilgang og som står i overvåkede lokaler. Overføring av personopplysninger over Internett er alltid beskyttet ved hjelp av kryptering.
</p>

<h4>ENDRINGER</h4>
<p>
Vi vil kunne gjøre endringer i personvernerklæringen. Vi vil i så fall informere deg om dette og du vil få mulighet til å slutte å bruke tjenesten.
</p>

<h4>KONTAKT</h4>
<p>
Dersom du ønsker å kontakte oss for å få innsyn i hvilke personopplysninger som er lagret må du av sikkerhetsmessige grunner sende inn en skriftlig henvendelse med signatur og kopi av legitimasjon med en redegjørelse for hvilke opplysninger du ønsker innsyn i. Henvendelsen kan skannes inn og sendes per e-post til: 
</p>
<p>
hello@orderx.no
</p>

<p>Opplysningene sendes per post til din folkeregistrerte adresse.</p>
`;
